module.exports = __webpack_public_path__ + "img/twitter-b.d8598268.svg";